import { Form, Input } from "antd";
import postalCodes from "../../../config/postal-codes.json";
import { useTranslation } from "react-i18next";

// postal-codes.json stores a description, not an input mask: "NNNN-NNN (NNNN NNN)",
// "NNNNN (optionally NNNNN-NNNN)", "- no codes -". Keep the leading mask, drop the
// trailing alternative, and show nothing when what is left is not a mask.
const POSTAL_CODE_MASK = /^[0-9A-Z][0-9A-Z \-]*$/;

export const postalCodePlaceholder = (format) => {
  if (!format) return "";
  const mask = format
    .replace(/\s*\([^()]*\)\s*$/, "")
    .trim()
    .replace(/N/g, "0");
  return POSTAL_CODE_MASK.test(mask) ? mask : "";
};

const PostalCode = ({ required, selectedCountry }) => {
  const { t } = useTranslation();
  const postalCodeFormat = postalCodes.find((p) => p.ISO === selectedCountry);
  return (
    <Form.Item name="postal_code" label={t("billing.postalCodeLabel")} rules={[{ required: required, message: t("billing.postalCodeRequired") }]} hasFeedback>
      <Input className="postal-code" placeholder={postalCodePlaceholder(postalCodeFormat?.Format)} />
    </Form.Item>
  );
};

export default PostalCode;
